import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { OptionItem } from '../../../../../shared/models/option-translation.model';
import { OptionTranslateService } from '../../../../../shared/services/option-translate.service';
import { Utils } from '../../../../../Utils/utils';
import { customValidator } from '../../../../../Utils/validator';

import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../../shared/shared-imports';
import { FieldValue } from '../../../../../shared/constants/services.enum';

@Component({
  standalone:true,
  selector: 'app-add-edit-signatory',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './add-edit-signatory.component.html',
  styleUrl: './add-edit-signatory.component.scss'
})
export class AddEditSignatoryComponent {
private destroy$ = new Subject<void>();
  @Input() isOpen = false;
  @Input() title = '';
  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() onBtnClick = new EventEmitter<any>();
  fieldValue=FieldValue;
  form!: FormGroup;
  nationalities: OptionItem[] = [];
  roles: OptionItem[] = [];
  partnerTypes: OptionItem[] = [];
  standardOption: OptionItem[] = [];
  tyeOfAddUser: OptionItem[] = [];

  detailFound: boolean = false;

  // This method is used to initialize the class instance using fb and option translate service
  constructor(
    private fb: FormBuilder,
    private optionTranslateService: OptionTranslateService
  ) {
    this.form = this.fb.group({
      roles: [[], [Validators.required]],
      isResident: [null, [Validators.required]],
      emiratesId: [null],
      emiratesDob: this.fb.group({
        day: [null],
        month: [null],
        year: [null],
      }),
      passportNumber: [null],
      passportExpiry: this.fb.group({
        day: [null],
        month: [null],
        year: [null],
      }),
      nameEn: [null, [customValidator('english')]],
      nameAr: [null, [customValidator('arabic')]],
      nationality: [null],
      mobile: [null, [Validators.required]],
      email: [null, [Validators.required, customValidator('email')]],
    });

    //get options value
    const lang = (localStorage.getItem('selectedLang') as 'en' | 'ar') || 'en';
    this.nationalities = this.optionTranslateService.getOptions(
      'nationalities',
      lang
    );
     this.standardOption = this.optionTranslateService.getOptions(
      'standardOption',
      lang
    );
    this.roles = this.optionTranslateService.getOptions('roles', lang);
  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {   
    this.form.valueChanges.subscribe(() => this.applyValidation());
  }
  // This method is used to check if resident
  get isResident() { return this.form.get('isResident')!.value === '1'; }
  // This method is used to non resident
  get nonResident() { return this.form.get('isResident')!.value === '2'; }

   // This method is used to apply validation
   applyValidation() {
    if (this.isResident) {
      this.toggleRequired(this.form, true, [
        'emiratesId', 'emiratesDob.day', 'emiratesDob.month', 'emiratesDob.year'
      ]);
    }
    if (this.nonResident) {
      this.toggleRequired(this.form, true, [
        'passportNumber','passportExpiry.day','passportExpiry.month','passportExpiry.year','nameEn', 'nameAr','nationality'
      ]);
    }
  }

  // This method is used to toggle required using form, condition, and controls
  private toggleRequired(form: FormGroup, condition: boolean, controls: string[]): void {
    controls.forEach((key) => {
      const ctl = form.get(key)!;
      if (condition) {
        const validators = [Validators.required];
         if (key == 'email') {
          validators.push(customValidator('email'));
        }
        if (key == 'companyNameEn' || key == 'nameEn') {
          validators.push(customValidator('english'));
        }
        if (key == 'companyNameAr' || key == 'nameAr') {
          validators.push(customValidator('arabic'));
        }
        ctl.addValidators(validators);
      } else {
        ctl.clearValidators();
      }
      ctl.updateValueAndValidity({ emitEvent: false });
    });
  }

  
  filesList: any = [
    {
      name: 'MOA.jpg',
      url: '/files/MOA.jpg',
      size: '120KB',
    },
  ];

  // This method is used to handle file upload using file
  handleFileUpload(file: any) {
    // handle file upload
  }

  // This method is used to handle file remove using file
  handleFileRemove(file: any) {
    this.filesList = this.filesList.filter((f: any) => f !== file);
  }
  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Submit
  // This method is used to add signatory
  addSignatory() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      const invalidControls = Utils.getInvalidControls(this.form);
      console.warn('Invalid controls:', invalidControls);
      return;
    }
    this.onBtnClick.emit(this.form.value);
    this.close();
  }

  // Close Modal
  // This method is used to close
  close() {
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }
}
